import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card, Spinner } from "react-bootstrap";
import { Col, CardBody,  Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import Razorpay from 'razorpay';
import Axios from 'axios';
import { Badge } from "react-bootstrap";
import dateFormat from 'dateformat';
import { toast } from 'react-toastify';
import { logincheck } from '../Userlogin/Userlogin'



class Addmoney extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      "pay_amount":"",
      "amount": "",
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      wal_amount: 0,
      modal: false,
      paySlot: false,
      userData: [],
      paymentData: [],
	  vailddata:"",
	  amounts:"",
	  paymentidmode: ""
    };
    this.changeAmount = this.changeAmount.bind(this);
    this.openCheckout = this.openCheckout.bind(this);
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  changeAmount(e) {
	var digit	=	e.target.value
	// alert(digit)
	digit	=	digit.indexOf(".")>0? digit.split(".").length>=2? digit.split(".")[0]+"."+digit.split(".")[1].substring(-1,2) : digit : digit
		// alert(digit)
	if(e.target.value > 500000) {
		toast.dismiss()
		toast.error("Maximum Limit is 500000", {
		position: toast.POSITION.TOP_CENTER,
		autoClose: 3000
		});
		this.setState({ pay_amount: '500000', amounts:  '500000'  });
	}
	else {
		this.setState({ pay_amount: digit});
		this.setState({amount: 100 * digit})
	}
    
    
  }

  openCheckout() {
    console.log(this.state.amount)
	
    if(this.state.amount == 0) 
	{
      this.setState({ vailddata: "1",  amounts: "0"});

    } 
    else if(this.state.amount < 10) {
		 this.setState({ vailddata: "1",  amounts: "10"});
      //alert('Please enter a Minimum Amount 10 ')
    }
    else {
	var camount = this.state.amount.toString()
	camount = camount.indexOf(".")>0? camount.split(".").length>=2? camount.split(".")[0]+"."+camount.split(".")[1].substring(-1,2) : camount : camount
	// alert(camount)
    let options = {
      "key": this.state.paymentidmode,
      "amount":  camount, // 2000 paise = INR 20, amount in paisa
      "name": "Gowatr",
      "user_d": this.props.userId,
      "description": "Add Money",
      "image": "/media/logos/newlogo.png",
      "prefill": {
       // "name": "Harshil Mathur",
        "email": this.props.uemail,
        "contact": this.props.umobile
      },
      handler: async (response) => {
        try {
          const doesToggle = this.state.paySlot;
          this.setState({  paySlot: !doesToggle })  
          const API_URL = process.env.REACT_APP_NODE_ENV;
          const bodyParameters = { 
            amount_data: camount,
            acc_amount: this.state.pay_amount,  
            user_id: this.props.userId,
            transtype: 'deposit'
         };
          

         const paymentId = response.razorpay_payment_id;
         const url = `${API_URL}/api/payment/${paymentId}`;
         const captureResponse = await Axios.post(url,bodyParameters, {})
         console.log(captureResponse.data);
         if(captureResponse.data) {
          this.props.history.push({ pathname: "/wallet/thankyou" });

         }
        } catch (err) {
          console.log(err);
        }
      },
      "theme": {
        "color": "#000080"  
      }
    };

    const rzp1 = new window.Razorpay(options);
       rzp1.open();
  }
  }

  
  componentDidMount() {
	  
	  logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		}) 
	   
	   let userdetails = { user_id : this.props.userId }
	   
    fetch(process.env.REACT_APP_NODE_ENV + '/api/customer/get_profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(userdetails)
    }).then((response) => response.json())
      .then(data => {
		  
		 if(data.length != 0) {
			
		}
		else {
			if(this.props.userRole === 'Individual Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
			}
			else if(this.props.userRole === 'Apartment Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/aprt-customer/customer-user-create", data: "" });
				
			}
		}
        
        
      })

    let postAddressData = { user_id : this.props.userId }
    fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/amount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postAddressData)
    }).then((response) => response.json())
      .then(data => {
        this.setState({ wal_amount : data.wallet_amount })
        //console.log(data.wallet_amount)
      })


      fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/transactionhistory', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postAddressData)
      }).then((response) => response.json())
        .then(data => {
          this.setState({ paymentData : data })
           //console.log(data)

        })
		
		 let postpayment = {}
		fetch(process.env.REACT_APP_NODE_ENV + '/api/configsetting/paymentfetchall', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postpayment)
      }).then((response) => response.json())
        .then(data => {
			// console.log(data.paymentdetails)
          if(data.paymentdetails.length > 0) {
		   this.setState({ paymentidmode: 	data.paymentdetails[0].payment_key_id    })
		  }
		  else {
			   this.setState({ paymentidmode: 	'0'	   })
		  }
         


        })

      
   
  }

 

  render() {

    let paySlots = null;
    if (this.state.paySlot) {
      paySlots = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Please Wait Payment is Processing ....</ModalHeader>
              <ModalBody>
                       <Spinner animation="border" />
              </ModalBody>
              <ModalFooter>
                  Do Not Refresh or GoBack
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    let dataArr = [];
    this.state.paymentData.map((data) => {
      let variant = "";
      let status = "";
      let transstatus ="";
      let variant1 = "";
      if (data.status === "captured" || data.status === "authorized" ) { status = "Success"; variant = "success" }
      if (data.transactionType === "deposit") { transstatus = "Add Money"; variant1 = "success" }
      else if (data.transactionType === "withdrawal") { transstatus = "withdraw"; variant1 = "danger"; status = "Success"; variant = "success"  }
	  else if (data.transactionType === "refund") { transstatus = "+ refund"; variant1 = "primary"; status = "Success"; variant = "success"  }


      let mdData = [
        data.payment_id,
        data.method, data.transaction_amount, transstatus + '&&' + variant1,  transstatus,  dateFormat(data.createdAt, 'dd-mmm-yyyy HH:mm:ss'),  status + '&&' + variant,  status
      ];
      dataArr.push(mdData)
      return null;
    });

    const columns = [
      {
        name: "transactionid",
        label: "Transaction Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "paymentmode",
        label: "Payment Mode",
        options: {
          filter: true,
          sort: true,
        }
      },
      
      {
        name: "amount",
        label: "Amount",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "transactiontype",
        label: "Transaction Type",
        options: {
          filter: false,
          sort: true,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  <Badge pill variant={datasFromValue[1]}>{datasFromValue[0]}</Badge>
            </>)
          }
        }
      },
      {
        name: "transactiontype",
        label: "Transaction Type1",
        options: {
          filter: false,
          sort: true,
          download: true,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  datasFromValue[0] </>)
          }
        }
      },
      {
        name: "datetime",
        label: "Date Time",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  <Badge pill variant={datasFromValue[1]}>{datasFromValue[0]}</Badge>
            </>)
          }
        }
      },
      {
        name: "status",
        label: "Status1",
        options: {
          filter: false,
          sort: true,
          download: true,
		  display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            let datasFromValue = value.split("&&")
            return (<>  datasFromValue[1]  </>)
          }
        }
      }
   
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
	  downloadOptions: {
        filename: 'Transaction List.csv',
      },
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

 
  


    


    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Individual Customer" || this.props.userRole === "Apartment Customer") {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Add Money</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}> 
          <div className="kt-form__section kt-form__section--first">
             <div className="kt-wizard-v1__form">
             {paySlots}
               
<Card>
  <Card.Header></Card.Header>
  <Card.Body>
     <div class="form-group row">
     <div className="col-lg-4">
        <label style= {{  fontSize:"16px" }}>Wallet Amount : RS. { this.state.wal_amount } </label>
       </div>
					<div className="col-lg-4">
							<input type='text'  pattern="^-?[0-9]\d*\.?\d*$" className="form-control" value={this.state.pay_amount} onChange={ this.changeAmount }  placeholder="Enter a Amount" />
							{(() => {
								if (this.state.vailddata != 0 || this.state.amounts === 0) {
									return (
									<div class="text-danger">Please enter a valid amount</div>
									)
								} else if (this.state.vailddata != 0 && this.state.amounts === 10) {
									return (
									<div class="text-danger">Please enter a valid amount</div>
									)
								} 
							})()}
						
						</div>
						<div className = "col-lg-2">
							<Button  variant="outline-success"   onClick={this.openCheckout}>Pay Rs. {this.state.amount/100}</Button> 
						</div> 
					</div> 
    
  </Card.Body>
</Card>

<MUIDataTable
              title={"Transaction List"}
              data={dataArr}
              columns={columns}
              options={options} />
              
                  </div> 
                
            </div>
           
          

          </div>
        </>
      );
    } else {
      return (<></>);
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
    uemail: state.auth.user[0].userEmail,
    umobile: state.auth.user[0].userPhoneNumber,
	mobiledevice: state.auth.user[0].mobiledeviceId,
  }
}

export default connect(
  mapStateToProps,
  null
)(Addmoney)